export function fireConfetti(options = {}) {
  try {
    if (typeof window !== "undefined" && window.confetti) {
      window.confetti({
        particleCount: 50,
        spread: 60,
        origin: { y: 0.6 },
        ...options,
      });
    }
  } catch {
    // silencioso
  }
}
